// extracted by mini-css-extract-plugin
export default {"container":"BF-z","header":"CF-z","details":"DF-z","link":"EF-z"};